// client/src/components/InventoryNav.jsx
import React from "react";
import "./InventoryNav.css"; // Optional: see CSS sample below

const InventoryNav = ({ selectedCategory, onCategorySelect }) => {
  // Include "All Items" plus the other categories.
  const categories = ["All Items", "Biology", "Chemistry", "Electrical", "Mechanical"];

  return (
    <nav className="inventory-nav">
      {categories.map((category) => (
        <button
          key={category}
          className={`nav-button ${selectedCategory === category ? "active" : ""}`}
          onClick={() => onCategorySelect(category)}
        >
          {category}
        </button>
      ))}
    </nav>
  );
};

export default InventoryNav;
